// "Works, But Wrong — the bugs that aren't crashes" — RAG correctness polish-pass short.
// Cold Compute / Neon kit. ~133s @ 30fps.
//
// GROUNDED in EAKC-MVP (four correctness fixes shipped 2026-06-12, after the
// crash-class bugs were already gone — the pipeline is green and STILL slightly wrong):
//   FIX 1 — semantic response cache (30-min TTL) would store a date-relative answer
//     ("the last 4 days") and serve it stale tomorrow. Fix: detect temporal queries
//     ("latest", "last N days", "recently") and never cache them.
//   FIX 2 — the changelog tool reported "30 new sources, 16,690 new chunks", but most
//     "new sources" were `agent_output`: the chat's OWN answers re-ingested as knowledge.
//     Fix: exclude agent_output from the changelog counts.
//   FIX 3 — the quality gate (CRAG) graded the retrieved chunks INCORRECT, then a live
//     date tool answered the question perfectly — wasting ~3-23s on a pointless broader
//     search. Fix: for temporal queries, defer grading to the tool (skip CRAG, pass through).
//   FIX 4 — answers ballooned to 3,000+ words by appending unsolicited "Potential YouTube
//     Content Ideas" / marketing roadmaps the user never asked for. Fix: a SCOPE DISCIPLINE
//     prompt rule — depth on the asked question is good, tangential padding is not.
// No fabricated numbers — the 30/16,690 counts, the 3,000+ word ballooning, the 30-min
// cache TTL, and the ~3-23s CRAG escalation cost are the real figures from the polish pass.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames @30fps; contiguous.
export const SCENE = {
  hook: { start: 0, duration: 450 }, //         0:00–0:15   pipeline green · four subtle things still wrong
  fix1: { start: 450, duration: 540 }, //       0:15–0:33   don't cache time · temporal queries never cached
  fix2: { start: 990, duration: 540 }, //       0:33–0:51   count real work, not your own questions
  fix3: { start: 1530, duration: 540 }, //      0:51–1:09   grade the right thing · tool answered, not retrieval
  fix4: { start: 2070, duration: 540 }, //      1:09–1:27   answer the question, then stop · scope discipline
  recap: { start: 2610, duration: 480 }, //     1:27–1:43   four fixes · no stack trace, just wrong
  lesson: { start: 3090, duration: 420 }, //    1:43–1:57   the system runs perfectly and is quietly wrong
  outro: { start: 3510, duration: 300 }, //     1:57–2:07
} as const;

export const TOTAL_DURATION = 3810; // 127s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
